import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { DeleteEventCommandInput, DeleteEventCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'deleteEvent'];

export function useDeleteEvent() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<DeleteEventCommandOutput, Error, DeleteEventCommandInput>({
    mutationKey: [...MUTATION_PREFIX],
    mutationFn: (input) => client.deleteEvent(input),
  });
}
